<template>
  <div class="container">
    <div class="row" v-if="!elements.textBox">
      <div class="col-lg-12">
        <div class="blog-area">
          <div class="blog-title">
            <h3>{{ elements.title }}</h3>
            <p>{{ elements.subTitle }}</p>
          </div>
          <div class="blog-text" v-html="elements.text"></div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-lg-6 align-self-center">
        <div class="blog-area">
          <div class="blog-title">
            <h3>{{ elements.title }}</h3>
            <p>
              {{ elements.subTitle }}
            </p>
          </div>
          <div class="blog-text" v-html="elements.text"></div>
        </div>
      </div>
      <div class="col-lg-6 align-self-center">
        <div class="textBox">
          <div class="team-containt" v-html="elements.textBox"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { translate } from '@/lib/utils';

export default {
  data() {
    return {};
  },
  computed: {
    elements() {
      if (this.type == 'noTitle') {
        delete this.textElements['title'];
        delete this.textElements['subTitle'];
      }
      return translate(this.textElements);
    }
  },
  props: {
    textElements: {
      type: Object
    },
    type: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.textBox {
  min-height: 300px;
  background: #fff;
  box-shadow: 0 0 10px #1425411a;
  border-radius: 8px;
  padding: 60px;
  margin-top: 60px;
}
</style>
